import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import Button from 'meinian-package/src/baseComponent/button'
import Icon from 'meinian-package/src/component/icon'
import Modal from 'meinian-package/src/component/modal'
import classNames from 'classnames'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import styles from './index.module.less'

export const renderDownloadModal = (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<DownloadModal {...props} visible container={div} />, div)
  })
}

const DownloadModal = ({
  visible,
  hiddenFolderLevel = false, // 是否按照按子灵感集创建层级文件夹下载
  onOk,
  onCancel
}) => { // 批量下载
  // type 1 全部图片 2 仅首图
  const [_visible, set_Visible] = useState(visible)
  const [type, setType] = useState(1)
  // 1默认 是，0 否
  const [keepStruct, setKeepStruct] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    if (isLoading) return
    setIsLoading(true)
    const flag = await onOk?.(type, hiddenFolderLevel ? keepStruct : null)
    setIsLoading(false)
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  return <Modal
    title="选择下载方式"
    visible={_visible}
    onClose={_cancel}
    onVisibleChange={vis => set_Visible(vis)}
    onOk={_ok}
    style={{ width: '480px', minHeight: '0' }}
    className={styles.mnDownloadModal}
    hiddenFooter
  >
    <div className={styles.mnDownload}>
      <div className="mnDownload-content">
        <div className={classNames('mnDownload-radio-card', { active: type === 1 })} onClick={() => setType(1)}>
          {
            type === 1 && <Icon type="m-xiaoyan" className="mnDownload-radio-card-icon" />
          }全部图片
        </div>
        <div className={classNames('mnDownload-radio-card', { active: type === 2 })} style={{ marginLeft: '16px' }} onClick={() => setType(2)}>
          {
            type === 2 && <Icon type="m-xiaoyan" className="mnDownload-radio-card-icon" />
          }仅首图
        </div>
      </div>
      <div className="mnDownload-footer">
        <div>
          {
            hiddenFolderLevel && <Checkbox
              checked={!!keepStruct}
              onChange={(e) => {
                setKeepStruct(e.target.checked ? 1 : 0)
              }}
            >按子灵感集创建层级文件夹</Checkbox>
          }
        </div>
        <div>
          <Button type="normal" onClick={_cancel} style={{ marginRight: 8, width: 88 }}>取消</Button>
          <Button type="primary" style={{ width: 88 }} onClick={_ok}>确定</Button>
        </div>
      </div>
    </div>
  </Modal>
}
